import React from 'react';
import { horizontalLine } from './styles';

export type Props = { styleOverride?: any };

export default function HorizontalLine(props: Props) {
  const { styleOverride } = props;
  return <div style={{ ...horizontalLine, ...styleOverride }} />;
}
